<template>
<!-- 方块 进入直播间 -->
<!-- 面包屑 -->
<div class="page cube">
    <crumbs :arr="crumbsArr" class="breaCrumbs" :showWater="showWater"></crumbs>
    <a href="javascript:;" class="gotoBack" @click="backPai"><i class="el-icon-arrow-left" style="margin-right:5px;"></i>返回拍卖会</a>
    <!--竞投咨询-->
    <!-- <div class="flex marTop10">
                <contact :contactData="specialData"></contact>
                <div class="auctionView" v-if="onlineUrl" @click="zxpClick">
                    <span class="auctionTitle">在线竞拍 <span v-if="onlinePerson"><span class="line"></span> <i></i>{{onlinePerson}}</span></span>
                </div>
            </div> -->
    <div class="cube-outbox">
        <div class="cube-left" id="mm">
            <!--5-结拍 4-拍卖中  3-带预展 2-预展中 1-待拍卖-->
            <!-- 此处没有加上预展状态 -->
            <div :class="['status',specialDetail.status == 1? 'status1' : '', specialDetail.status == 4 ? 'status2': '', specialDetail.status == 5? 'status3': '',specialDetail.status == 2? 'status4': '',specialDetail.status == 3? 'status5': '',]"></div>
            <img :src="specialDetail.picUrlNew" alt="">
            <!-- <h3 class="columnTit">
                        <span>{{ name }}</span>
                    </h3>
                    <div style="margin: 20px 30px">
                        <div class="marin">
                            <div
                                class="marin-item"
                                v-for="(item, index) in labelList"
                                :key="index"
                            >
                                {{ item.name }}
                            </div>
                            <div class="marin-item gotoVr" v-if="vrInfo.vrType && vrInfo.vrType == 2" @click="gotoVr">
                                VR
                            </div>
                        </div>
                        <div class="paimai-sum">
                            <template v-for="(item, index) in detailExtraInfo">
                                <div class="sum-item" :key="index" v-if="item.name == 'total'">
                                    <span class="tit">{{ item.label }}</span>
                                    <span class="cont">{{item.text}}</span>
                                </div>
                            </template>
                            <template v-for="(item, index) in detailExtraInfo">
                                <div class="sum-item" :key="index" v-if="item.name == 'auction_date'">
                                    <span class="tit">{{ item.label }}</span>
                                    <span class="cont">{{item.text}}</span>
                                </div>
                            </template>
                            <template v-for="(item, index) in detailExtraInfo">
                                <div class="sum-item" :key="index" v-if="item.name == 'auction_place'">
                                    <span class="tit">{{ item.label }}</span>
                                    <span class="cont">{{item.text}}</span>
                                </div>
                            </template>
                        </div>
                        <div class="paimai-sum" v-if="status!=5">
                            <template v-for="(item, index) in daiPaiExtraInfo">
                                <div class="sum-item" :key="index">
                                    <span class="tit">{{ item.label }}</span>
                                    <span class="cont">{{item.text}}</span>
                                </div>
                            </template>
                        </div>
                        <div class="paimai-sum" v-else>
                            <template v-for="(item,idx) in detailExtraInfo">
                                <div class="sum-item" :key="idx" v-if="item.label == '成交总额' || item.label == '成交率'">
                                    <span class="tit">{{ item.label }}</span>
                                    <span class="cont ">{{item.text}}</span>
                                </div>
                            </template>
                        </div>
                        <div class="upFix">
                            <template v-if="liveInfo!=null && liveInfo.have_live > 0">
                                <template v-if="liveInfo.have_review == 1 && liveInfo.live_status == 4">
                                    <a href="javascript:;" @click="gotoLive(liveInfo)">直播回放</a>
                                </template>
                                <template v-else-if="liveInfo.live_status == 0 || liveInfo.live_status == 1">
                                    <a href="javascript:;" @click="gotoLive(liveInfo)">即将开播</a>
                                </template>
                                <template v-else-if="liveInfo.live_status == 2">
                                    <a href="javascript:;" @click="gotoLive(liveInfo)">进入直播间</a>
                                </template>
                            </template>
                            <a href="javascript:;" v-if="vrInfo.vrType && vrInfo.vrType == 2" @click="gotoVr">VR看展</a>
                            <a :href="podDetailLink" target="_blank" v-if="havePdf==1">电子书</a>
                            <a href="javascript:;" class="gotoBack" @click="backPai">返回拍卖会</a>
                        </div>
                    </div>  -->
        </div>
        <div class="cube-right" id="nn">
            <h3 class="columnTit">
                {{ specialDetail.name }}
            </h3>
            <div>
                <div class="bitTip" v-if="specialDetail.live_info.bid_type==1||specialDetail.live_info.bid_type==2">{{specialDetail.live_info.bid_type_name}}</div>
            </div>
            <div style="margin: 20px 0 0 0;min-height: 175px;">
                <div class="paimai-sum">
                    <div class="sum-item" v-if="specialDetail.deposit_percent != ''">
                        <span class="tit">保证金</span>
                        <span class="cont">{{specialDetail.deposit_percent}}</span>
                    </div>
                    <div class="sum-item" v-if="specialDetail.commission != ''">
                        <span class="tit">佣金</span>
                        <span class="cont">{{specialDetail.commission}}</span>
                    </div>

                    <template v-for="(item, index) in detailExtraInfo">
                        <div class="sum-item" :key="index" v-if="item.name == 'total'">
                            <span class="tit">{{ item.label }}</span>
                            <span class="cont">{{item.text}}</span>
                        </div>
                    </template>
                    <template v-for="(item, index) in detailExtraInfo">
                        <div class="sum-item" :key="index" v-if="item.name == 'auction_date'">
                            <span class="tit">{{ item.label }}</span>
                            <span class="cont">{{item.text}}</span>
                        </div>
                    </template>
                    <template v-for="(item, index) in detailExtraInfo">
                        <div class="sum-item" :key="index" v-if="item.name == 'auction_place'">
                            <span class="tit">{{ item.label }}</span>
                            <span class="cont">{{item.text}}</span>
                        </div>
                    </template>
                    <template v-for="(item, index) in detailExtraInfo">
                        <div class="sum-item" :key="index" v-if="item.name == 'organ_name'">
                            <span class="tit">{{ item.label }}</span>
                            <span class="cont">{{item.text}}</span>
                        </div>
                    </template>
                    <template v-if="status!=5">
                        <template v-for="(item, index) in daiPaiExtraInfo">
                            <div class="sum-item" :key="index">
                                <span class="tit">{{ item.label }}</span>
                                <span class="cont">{{item.text}}</span>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="(item,idx) in detailExtraInfo">
                            <div class="sum-item" :key="idx" v-if="item.label == '成交总额' || item.label == '成交率'">
                                <span class="tit">{{ item.label }}</span>
                                <span class="cont ">{{item.text}}</span>
                            </div>
                        </template>
                    </template>
                    <template>
                        <template v-for="(item,idx) in detailExtraInfo">
                            <div class="sum-item" :key="idx" v-if="item.type == 'culturalLicense'">
                                <span class="tit">{{ item.label }}</span>
                                <span @click="showLicense(item.pic)" style="cursor: pointer;" class="cont ">{{item.text}}<i class="el-icon-arrow-right" style="color: #333;margin-left:5px;"></i></span>
                            </div>
                        </template>
                    </template>

                    <!-- <div class="sum-item" v-if="arr.Address">
                                <span class="tit">地址</span>
                                <span class="cont">{{ arr.Address }}</span>
                            </div>
                            <div class="sum-item" v-if="arr.PostCode">
                                <span class="tit">邮编</span>
                                <span class="cont">{{ arr.PostCode }}</span>
                            </div>
                            <div class="sum-item" v-if="arr.Phone">
                                <span class="tit">电话</span>
                                <span class="cont">{{ arr.Phone }}</span>
                            </div>
                            <div class="sum-item" v-if="arr.Fax">
                                <span class="tit">传真</span>
                                <span class="cont">{{ arr.Fax }}</span>
                            </div>
                            <div class="sum-item" v-if="arr.Email">
                                <span class="tit">邮件</span>
                                <span class="cont"><a :href="'mailto:'+arr.Email">{{ arr.Email }}</a></span>
                            </div>
                            <div class="sum-item" v-if="arr.WebUrl">
                                <span class="tit">网址</span>
                                <span class="cont"><a :href="arr.WebUrl.indexOf('https') == -1 || arr.WebUrl.indexOf('http') == -1 ? 'http://'+arr.WebUrl : arr.WebUrl" target="_blank">{{ arr.WebUrl }}</a></span>
                            </div>
                            <div class="sum-item qrCodeFu" v-if="arr.MiroblogPic">
                                <span class="tit">公众号</span>
                                <span class="cont" @mouseenter="mouseEnter" @mouseleave="mouseLeave">鼠标移入查看微信公众号二维码
                                <div class="qrCodeDiv" v-show="qrCodeState">
                                    <img :src="arr.MiroblogPic">
                                    <div>打开微信【扫一扫】</div>
                                    <div>扫描二维码</div>
                                </div>
                                </span>
    
                            </div> -->
                </div>

            </div>
            <div class="upFix">
                <a v-if="specialDetail.live_info.bid_status!=3&&specialDetail.live_info.bid_status!=0" href="javascript:;" @click="gotoDown()">下载App&nbsp;参与现场出价</a>
                <a style="background: #EAF5E7;color: #329D15;border:1px solid rgba(50, 157, 21, 0.30);" :href="podDetailLink" target="_blank" v-if="havePdf==1">电子书</a>
                <template v-if="liveInfo!=null && liveInfo.have_live > 0&&!(specialDetail.live_info.bid_status!=3&&specialDetail.live_info.bid_status!=0)">
                    <template v-if="liveInfo.have_review == 1 && liveInfo.live_status == 4">
                        <a href="javascript:;" @click="gotoLive(liveInfo)">直播回放</a>
                    </template>
                    <template v-else-if="liveInfo.live_status == 0 || liveInfo.live_status == 1">
                        <a href="javascript:;" @click="gotoLive(liveInfo)">即将开播</a>
                    </template>
                    <template v-else-if="liveInfo.live_status == 2">
                        <a href="javascript:;" @click="gotoLive(liveInfo)">进入直播间</a>
                    </template>
                </template>
                <a href="javascript:;" v-if="vrInfo.vrType && vrInfo.vrType == 2" @click="gotoVr">VR看展</a>
                <!-- <template v-if="liveInfo!=null && liveInfo.have_live > 0">
                            <template v-if="liveInfo.have_review == 1 && liveInfo.live_status == 4">
                                <a href="javascript:;" @click="gotoLive(liveInfo)">直播回放</a>
                            </template>
                            <template v-else-if="liveInfo.live_status == 0 || liveInfo.live_status == 1">
                                <a href="javascript:;" @click="gotoLive(liveInfo)">即将开播</a>
                            </template>
                            <template v-else-if="liveInfo.live_status == 2">
                                <a href="javascript:;" @click="gotoLive(liveInfo)">进入直播间</a>
                            </template>
                        </template>
                        <a href="javascript:;" v-if="vrInfo.vrType && vrInfo.vrType == 2" @click="gotoVr">VR看展</a> -->
                <!-- <a :href="podDetailLink" target="_blank" v-if="havePdf==1">电子书</a>
                        <a href="javascript:;" class="gotoBack" @click="backPai">返回拍卖会</a> -->
            </div>

        </div>
    </div>
    <el-dialog title="" :visible.sync="licenseFlag" width="70%">
        <div style=" width: 100%; height: 70vh;">
            <img style=" height: 100%;  object-fit: contain;" :src="licenseImg" alt="">
        </div>

    </el-dialog>
</div>
</template>

<script>
// import { aucSpec } from "@/api/spec";
import {
    getOrgInfo
} from "@/api/organ";
import {
    agencyarr
} from "@/api/auction";
import crumbs from "@/components/crumbs";
// import {
//     sendScData
// } from "@/utils/buriedPoint";
// import contact from "@/components/common/contact";
export default {
    props: {
        specialDetail: {
            type: Object
        },
        specialCode: {
            type: String,
        },
        showWater: {
            type: Boolean
        },
        name: {
            type: String
        },
        labelList: {
            type: Array
        },
        detailExtraInfo: {
            type: Array
        },
        daiPaiExtraInfo: {
            type: Array
        },
        liveInfo: {
            type: Object,
            default: function () {
                return {
                    have_live: 0,
                    have_review: 0,
                    live_status: 0,
                    label_list: []
                }
            }
        },
        vrInfo: {
            vrLink: "",
            vrModelId: 0,
            vrType: 0
        },
        sessionCode: {
            type: String
        },
        organCode: {
            type: String
        },
        status: {
            type: Number
        },
        zxpUrl: {
            type: String
        },
        havePdf: {
            type: Number
        },
        podDetailLink: {
            type: String
        },
        onlinePerson: {
            type: Number
        },
        onlineUrl: {
            type: String
        }
    },
    watch: {
        specialDetail: {
            immediate: true,
            handler(val) {
                this.specialData = val
            }
        }
    },
    data() {
        return {
            params: {
                specialCode: '',
                orderby: 1,
                keyword: "",
            },
            isLogin: 0,
            organParams: {
                organCode: '',
                language: "zh-CN",
            },
            arr: [],
            crumbsArr: [{
                    name: "雅昌拍卖首页",
                    path: "/"
                },
                {
                    name: '雅昌拍卖预展',
                    path: '/preauction'
                },
                {
                    name: "中国书画拍卖专场",
                    path: "/"
                },

            ],
            isShowOnline: false,
            orgInfo: '',
            qrCodeState: false,
            specialData: null,
            licenseFlag: false,
            licenseImg: ''
            // sessionCode:''
        };
    },
    components: {
        crumbs
    },
    mounted() {
        this.getAgencyarr()
        this.crumbsArr[2].name = this.name
        this.crumbsArr[2].path = '/special_detail/' + this.$route.params.id
        this.crumbsArr[1].name = this.status == 5 ? '雅昌拍卖结果' : '雅昌拍卖预展'
        this.crumbsArr[1].path = this.status == 5 ? '/result' : '/preauction'
        if (this.getCookie("_at_pt_0_")) {
            this.isLogin = 1
        }
    },
    methods: {
        gotoDown() {
            window.location.href = "https://artexpress.artron.net/download/tulu"
        },
        showLicense(e) {
            if (e) {
                this.licenseFlag = true;
                this.licenseImg = e
            }

        },
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            } else {
                return null;
            }
        },
        gotoVr() {
            window.open(this.vrInfo.vrLink)
        },
        gotoLive(json) {
            let specialId = json.special_id
            let liveId = json.lives[0].live_id
            window.open('https://auction.artron.net/live/detail?id=' + liveId + '&special_id=' + specialId)
        },
        backPai() {
            this.$router.push({
                path: '/meeting_detail/' + this.sessionCode,
            })
        },
        // 拍卖机构公司  organCode是从详情列表来的
        getAgencyarr() {
            this.organParams.organCode = this.organCode
            agencyarr(this.organParams).then((res) => {
                if (res.code == 0) {
                    this.arr = res.data;
                }
                getOrgInfo(this.organCode)
            });
        },
        gotoLogin() {
            if (this.$route.query.from) {
                return false
            }
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        },
        mouseEnter() {
            this.qrCodeState = true
        },
        mouseLeave() {
            this.qrCodeState = false
        },
        zxpClick() {
            this.$emit('onlineClick')
        }
    },
};
</script>

<style lang="scss" scoped>
.cube {
    width: 1180px;
    margin: auto;

    .cube-outbox {
        width: 100%;
        display: flex;
        margin-top: 10px;
        justify-content: normal;

        .cube-left {
            width: 494px;
            border-radius: 12px;
            margin-right: 20px;
            overflow: hidden;
            position: relative;

            .status {
                position: absolute;
                top: 16px;
                right: 16px;
                color: #fff;
            }

            .status1::after {
                content: "待拍卖";
                width: 52px;
                height: 27px;
                text-align: center;
                line-height: 25px;
                padding: 0 5px;
                background: #18BD6F;
                display: inline-block;
                border-radius: 25px 25px 25px 25px;

            }

            .status2::after {
                content: "拍卖中";
                width: 52px;
                height: 27px;
                text-align: center;
                line-height: 25px;
                padding: 0 5px;
                background: #E35458;
                display: inline-block;
                border-radius: 25px 25px 25px 25px;

            }

            .status3::after {
                content: "已结拍";
                width: 52px;
                height: 27px;
                text-align: center;
                line-height: 25px;
                padding: 0 5px;
                background: rgba(0, 0, 0, 0.2);
                display: inline-block;
                border-radius: 25px 25px 25px 25px;

            }

            .status4::after {
                content: "预展中";
                width: 52px;
                height: 27px;
                text-align: center;
                line-height: 25px;
                padding: 0 5px;
                background: #18BD6F;
                display: inline-block;
                border-radius: 25px 25px 25px 25px;

            }

            .status5::after {
                content: "已结拍";
                width: 52px;
                height: 27px;
                text-align: center;
                line-height: 25px;
                padding: 0 5px;
                background: #656565;
                display: inline-block;
                border-radius: 25px 25px 25px 25px;

            }

            img {
                height: 278px;
                border-radius: 12px;

            }

            // height: 392px;
            // 标题
            // .columnTit {
            //     margin: auto;
            //     font-size: 24px;
            //     font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            //     font-weight: bold;
            //     color: #262626;
            //     padding-bottom: 0;
            // }
            // // 保证金
            // .marin {
            //     display: flex;
            //     .marin-item {
            //         height: 20px;
            //         border: 1px solid #d9d9d9;
            //         padding: 0px 4px;
            //         line-height: 20px;
            //         font-size: 12px;
            //         border-radius: 4px;
            //         font-family: MicrosoftYaHei;
            //         color: #8c8c8c;
            //         margin-right: 10px;
            //     }
            //     .gotoVr{cursor: pointer;}
            //     .gotoVr:hover{border-color: #0f820c;color:#0f820c;}
            // }
            // .paimai-sum {
            //     margin: 20px 0px;
            //     .sum-item {
            //         display: flex;
            //         justify-content: space-between;
            //         span {
            //             display: inline-block;
            //             margin-bottom: 5px;
            //         }
            //         .item-red,a.item-red{color:#F5222D;}
            //         .tit {
            //             width: 95px;
            //             font-size: 14px;
            //             font-family: MicrosoftYaHei;
            //             color: #8c8c8c;
            //             overflow: hidden;
            //             text-overflow: ellipsis;
            //             white-space: nowrap;
            //         }
            //         .cont {
            //             width: calc(100% - 100px);
            //             font-size: 14px;
            //             font-family: MicrosoftYaHei;
            //             color: #262626;
            //         }
            //     }
            // }
            // .paimai-brokerage {
            //     padding-bottom: 20px;
            //     .brokerage-item {
            //         display: flex;
            //         justify-content: space-between;
            //         span {
            //             display: inline-block;
            //             margin-bottom: 5px;
            //         }
            //         .tit {
            //             display: flex;
            //             align-items: center;
            //             width: 95px;
            //             span {
            //                 font-size: 14px;
            //                 font-family: MicrosoftYaHei;
            //                 color: #8c8c8c;
            //                 overflow: hidden;
            //                 text-overflow: ellipsis;
            //                 white-space: nowrap;
            //             }
            //             .mark {
            //                 margin-left: 4px;
            //             }
            //         }
            //         .cont {
            //             width: calc(100% - 100px);
            //             font-size: 14px;
            //             font-family: MicrosoftYaHei;
            //             color: #262626;
            //         }
            //     }
            // }
            // // 按钮样式
            // .upLive {
            //     // padding: 0px 30px;
            //     display: flex;
            //     justify-content: space-between;
            //     align-items: center;

            //     .upLive-left {
            //         width: 310px;
            //         height: 46px;
            //         background: #329d15;
            //         border-radius: 4px;
            //         cursor: pointer;
            //         transition: .2s background-color ease-in-out;

            //         font-size: 18px;
            //         font-family: MicrosoftYaHei;
            //         color: #ffffff;
            //         line-height: 46px;
            //         text-align: center;
            //     }
            //     .upLive-left:hover{background-color: #0F820C}
            //     .upLive-left-black{background-color: #333;}
            //     .upLive-left-black:hover{background-color: #000}
            //     .upLive-right {
            //         width: 190px;
            //         height: 46px;
            //         background: #eaf5e7;
            //         border-radius: 4px;
            //         border: 1px solid #329d15;
            //         font-size: 18px;
            //         font-family: MicrosoftYaHei;
            //         color: #329d15;
            //         line-height: 46px;
            //         text-align: center;
            //         cursor: pointer;
            //         transition: .2s background-color ease-in-out;
            //     }
            //     .upLive-right:hover{background-color: #329d15;color:#fff;}
            // }
            // .upLiveOne {
            //     .upLive-rightone {
            //         width: 510px;
            //         height: 46px;
            //         cursor: pointer;
            //         background: #eaf5e7;
            //         border-radius: 4px;
            //         border: 1px solid #329d15;
            //         font-size: 18px;
            //         font-family: MicrosoftYaHei;
            //         color: #329d15;
            //         line-height: 46px;
            //         text-align: center;
            //     }
            // }
        }

        .cube-right {
            width: 580px;

            // height: 392px;
            .bitTip {
                border: 1px solid #D9D9D9;
                font-size: 12px;
                font-weight: 400;
                color: #000000;
                padding: 4px 10px;
                display: inline-block;
                border-radius: 4px;
                margin: 12px 0;

            }

            .columnTit {
                width: 100%;
                padding-top: 5px;
                margin: auto;
                font-size: 24px;
                padding-bottom: 0;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #262626;
            }

            .paimai-sum {
                margin: 20px 0px;
                padding-top: 20px;
                border-top: 1px solid rgba(0, 0, 0, 0.1);

                .sum-item {
                    display: flex;
                    justify-content: space-between;

                    span {
                        display: inline-block;
                        margin-bottom: 12px;
                    }

                    .tit {
                        width: 85px;
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: #8c8c8c;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .cont {
                        width: calc(100% - 59px);
                        font-size: 14px;
                        font-weight: bolder;
                        font-family: MicrosoftYaHei;
                        color: #262626;
                    }
                }
            }
        }
    }

    .marTop10 {
        margin-top: 10px;
    }

    .auctionView {
        width: 280px;
        height: 40px;
        background: #329D15;
        border-radius: 4px;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        text-align: center;
        display: block;
        margin-left: 20px;
        cursor: pointer;

        &:hover {
            color: #ffffff;
            text-decoration: none;
        }

        .line {
            width: 1px;
            height: 12px;
            opacity: 0.4;
            border: 1px solid #FFFFFF;
            display: inline-block;
            margin: 0 15px;
        }

        i {
            background: url(../../../../assets/imgs/icon_portrait.png) no-repeat center center;
            background-size: 100% 100%;
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-right: 5px;
            vertical-align: middle;
            margin-top: -3px;
        }
    }
}

.erCode {
    font-size: 14px;
    color: #8c8c8c;
}

.qrCodeFu {
    position: relative;
}

.erCode {
    cursor: pointer;
}

.qrCodeDiv {
    position: absolute;
    text-align: center;
    top: 32px;
    color: #8C8C8C;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    padding: 10px;
    font-size: 12px;
    z-index: 9;

    img {
        width: 78px;
        height: 78px;
        margin-bottom: 10px;
    }

    div {
        line-height: 20px;
    }
}

.yiruCode {
    &:hover {
        color: #5bb2e4;
    }
}

.upFix {
    display: flex;
    justify-content: space-between;

    a {
        border: 1px solid #329D15;
        height: 44px;
        line-height: 42px;
        text-align: center;
        color: #fff;
        background-color: #329d15;
        border-radius: 4px;
        flex-grow: 4;
        margin-left: 20px;
        font-size: 16px;
    }

    a:first-child {
        margin-left: 0;
    }
}

a.gotoBack {
    padding: 17px 5px;
    font-weight: 400;
    font-size: 14px;
    color: #000000;

    &:hover {
        color: #329d15 !important;
    }
}
</style>
